import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchUsers } from "../../actions/user";
import { NavLink } from "react-router-dom";
import { Loader } from "../loader";
import { NotificationManager } from "react-notifications";
import { toggleUserStatus, deleteUserPerm } from "../../actions/user";
import history from "../../history.js";

const $ = window.$;
const initialState = {
  users: [],
  selectedU: { UserPetstores: [{}] },
  loading: false
};

class Datasections extends React.Component {
  constructor(props) {
    super(props);
  }

  state = initialState;

  openConfirmDeactivateModal = u => {
    this.setState({ selectedU: u });
    $("#confirm_deact_modal").modal("show");
  };

  deactUser = () => {
    this.setState({ loading: true });

    if (this.state.selectedU) this.props.toggleUserStatus(this.state.selectedU);
    else {
      NotificationManager.warning("User not available.");
      this.setState({ loading: false });
    }
  };
  deleteUser = () => {
    this.setState({ loading: true });
    if (this.state.selectedU) this.props.deleteUserPerm(this.state.selectedU);
    else {
      NotificationManager.warning("User not available.");
      this.setState({ loading: false });
    }
  };

  resetState = () => {
    this.setState(initialState);
  };

  onLogout = () => {
    if (this.props.user != null) {
      this.props.user.signOut();
      history.replace("/login");
    }
  };
  openConfirmDeleteModal = u => {
    this.setState({ selectedU: u });
    $("#confirm_delete_modal").modal("show");
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.data.users !== nextProps.data.users) {
      this.setState({ users: nextProps.data.users });
    }

    if (this.props.data.newUser !== nextProps.data.newUser) {
      if (nextProps.data.newUser && nextProps.data.newUser.id) {
        this.props.fetchUsers();
      }
    }
    if (this.props.data.deletedUser !== nextProps.data.deletedUser) {
      $("#confirm_delete_modal").modal("hide");
      this.props.fetchUsers();
      NotificationManager.success("User deleted successfully");
    }

    if (this.props.data.statusUser !== nextProps.data.statusUser) {
      $("#confirm_deact_modal").modal("hide");
      this.resetState();
      this.props.fetchUsers();
      NotificationManager.success("User status updated successfully");
      if (
        nextProps.data.statusUser.UserId === this.props.data.currentUser.id &&
        nextProps.data.statusUser.status === "Deactivated"
      ) {
        this.onLogout();
        NotificationManager.error("Please login");
      }
    }
  };

  componentDidMount = () => {
    this.props.fetchUsers();
  };

  render() {
    const { users } = this.state;
    return (
      <div className="row">
        {users.map(u => (
          <div key={u.id} className="col-xs-12 col-sm-6 col-xl-4">
            <div className="m-portlet m-portlet--full-height ">
              <div className="m-portlet__body pt-3 pb-3">
                <div className="m-widget4">
                  <div className="m-widget4__item">
                    <div className="m-widget4__img m-widget4__img--pic">
                      {u.UserPetstores[0].avatar_file_name ? (
                        <img
                          src={
                            process.env.REACT_APP_S3_PATH +
                            "/" +
                            u.UserPetstores[0].avatar_path +
                            "/" +
                            u.UserPetstores[0].avatar_file_name
                          }
                          alt=""
                        />
                      ) : u.UserPetstores[0].gender === "male" ? (
                        <img
                          src="../assets/app/media/img/users/men_sample.png"
                          alt=""
                        />
                      ) : (
                        <img
                          src="../assets/app/media/img/users/women_sample.png"
                          alt=""
                        />
                      )}
                    </div>
                    <div className="m-widget4__info">
                      <span className="m-widget4__title">
                        {u.UserPetstores[0].firstname}{" "}
                        {u.UserPetstores[0].lastname}
                      </span>
                      <br />
                      <span className="m-widget4__sub">
                        {u.UserPetstores[0].Role.role_name}
                      </span>
                      <br />
                      <span className="m-widget4__sub">
                        {u.UserPetstores[0].status === "Active" ? (
                          <div>
                            <span className="m-badge m-badge--info m-badge--dot"></span>
                            <span className="m--font-info">
                              {" "}
                              {u.UserPetstores[0].status}
                            </span>
                          </div>
                        ) : (
                          <div>
                            <span className="m-badge m-badge--danger m-badge--dot"></span>
                            <span className="m--font-danger">
                              {" "}
                              {u.UserPetstores[0].status}
                            </span>
                          </div>
                        )}
                      </span>
                    </div>
                    <div className="m-widget4__ext center-text">
                      <NavLink
                        to={`/users/${u.id}`}
                        className="btn m-btn--pill  btn-sm btn-outline-primary mb-2"
                      >
                        View Profile
                      </NavLink>
                      {u.UserPetstores[0].status === "Active" ? (
                        <button
                          onClick={() => this.openConfirmDeactivateModal(u)}
                          className="btn m-btn--pill btn-sm btn-secondary m-btn m-btn--custom m-btn--label-secondary"
                        >
                          Deactivate
                        </button>
                      ) : (
                        <button
                          onClick={() => this.openConfirmDeactivateModal(u)}
                          className="btn m-btn--pill btn-sm btn-secondary m-btn m-btn--custom m-btn--label-success"
                        >
                          Activate
                        </button>
                      )}
                      {u.UserPetstores[0].Role.role_name !== "Admin" && (
                        <button
                          onClick={() => this.openConfirmDeleteModal(u)}
                          className="btn m-btn--pill btn-sm btn-secondary m-btn m-btn--custom m-btn--label-danger"
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="confirm_deact_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="ConfirmationModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        {this.state.selectedU.UserPetstores[0].status ===
                        "Active"
                          ? "Confirm to deactivate"
                          : "Confirm to activate"}
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        {this.state.selectedU.UserPetstores[0].status ===
                        "Active"
                          ? this.state.selectedU.id ===
                            this.props.data.currentUser.id
                            ? "You are going to deactivate your profile. You will be logged out from the system after deactivation. Please confirm to proceed"
                            : "Are you sure you want to deactivate this profile?"
                          : "Are you sure you want to activate this profile?"}
                      </p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loading == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deactUser()}
                            className="btn btn-primary m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="confirm_delete_modal"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="deleteModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="deleteModalLabel">
                        Confirm to delete
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>Are you sure you want to delete this profile?</p>
                    </div>
                    <div className="modal-footer">
                      {this.state.loading == false ? (
                        <div>
                          <button
                            type="button"
                            className="btn btn-secondary m-btn--pill mx-2"
                            data-dismiss="modal"
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            onClick={() => this.deleteUser()}
                            className="btn btn-danger m-btn--pill"
                          >
                            Confirm
                          </button>
                        </div>
                      ) : (
                        <div className="center-row">
                          <Loader size={50} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  fetchUsers: () => {
    dispatch(fetchUsers());
  },
  toggleUserStatus: user => {
    dispatch(toggleUserStatus(user));
  },
  deleteUserPerm: user => {
    dispatch(deleteUserPerm(user));
  }
});

const mapStateToProps = state => ({
  petShop: state.petShopReducer,
  user: state.cognito.user,
  data: state.userReducer
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Datasections)
);
